import { useNavigate, useParams } from "react-router-dom";
import { useGetAllRFQQuery } from "../../../store/apiSlices/adminApi";
import { QuoteRow } from "./QuoteRow";

export default function OngoingOrders() {
  const { uid } = useParams<{ uid: string }>();
  const navigate = useNavigate();

  const {
    data: rfqs,
    isLoading,
    isError,
  } = useGetAllRFQQuery({ uid: Number(uid) });

  const ongoingQuotes =
    rfqs?.filter((el) => el.status?.toLowerCase() === "confirmed") || [];

  return (
    <section className="card space-y-3">
      {/* Header */}
      <h2 className="text-gray-800 font-medium text-lg">
        Ongoing Orders ({ongoingQuotes.length})
      </h2>

      {/* Loading Skeleton */}
      {isLoading && (
        <div className="space-y-2 mt-6">
          {[...Array(4)].map((_, i) => (
            <div
              key={i}
              className="animate-pulse bg-gray-100 h-12 rounded-md"
            />
          ))}
        </div>
      )}

      {/* Error State */}
      {isError && (
        <p className="text-red-500 text-center py-6">
          Failed to load data. Please try again.
        </p>
      )}

      {/* Table */}
      {!isLoading && !isError && (
        <div className="rounded-lg border border-gray-200 bg-white overflow-hidden">
          <div className="h-80 overflow-y-auto">
            <table className="w-full text-sm table-fixed">
              <thead className="sticky top-0 z-10 bg-gray-50">
                <tr className="text-left text-gray-600">
                  <th className="px-4 py-3 font-medium w-[45%]">From → To</th>
                  <th className="px-4 py-3 font-medium w-[25%]">
                    Transaction ID
                  </th>
                  <th className="px-4 py-3 font-medium w-[15%]">Date</th>
                  <th className="px-4 py-3 font-medium w-[15%] text-center">
                    Task
                  </th>
                </tr>
              </thead>

              <tbody>
                {ongoingQuotes.length > 0 ? (
                  ongoingQuotes.map((quote) => (
                    <QuoteRow
                      key={quote.id || quote.quotes_id}
                      quote={quote}
                      onClick={() =>
                        navigate(
                          `ongoing-quotes/${quote.id || quote.quotes_id}`,
                        )
                      }
                    >
                      {quote.booking_medium === "procurement_request" ? (
                        <QuoteRow.ProcurementRequest
                          location={quote.procurement_location}
                          description={quote.goods_description}
                        />
                      ) : (
                        <QuoteRow.Route
                          from={quote.from_json?.name}
                          to={quote.to_json?.name}
                          freightType={quote.freight_type}
                          weight={quote.weight}
                        />
                      )}

                      <QuoteRow.TransactionId id={quote.transaction_id} />

                      <QuoteRow.Date date={quote.created_at} />
                      <QuoteRow.Task />
                    </QuoteRow>
                  ))
                ) : (
                  <tr>
                    <td colSpan={4} className="py-12 text-center text-gray-500">
                      No RFQs found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </section>
  );
}
